module.exports = __webpack_public_path__ + "static/media/books.cfbc92e8.png";